module.exports = new __parcel__URL__("logo_dirm.b6c964ef.jpg").toString();